import React from 'react'
import * as R from 'remeda'

import { type ColumnInfo, getDiffKey, groupsAndAll } from '~/utils'

import { useAtomValueContext } from '../providers/AtomsProvider'
import {
  getColumnInfos,
  type GroupsDiffColumnKey,
  type IndividualColumnKey,
} from '../utils'

import { useTabulatedGroupsAndAll } from './useTabulatedGroupsAndAll'

const widthMap: Record<
  Exclude<IndividualColumnKey, GroupsDiffColumnKey>,
  string
> = {
  answerText: 'max-content',
  ...R.mapToObj(groupsAndAll, (group) => [group, '5.5em']),
}

export const useIndividualTableColumns =
  (): ColumnInfo<IndividualColumnKey>[] => {
    const tabulatedGroupsAndAll = useTabulatedGroupsAndAll()
    const groupsDiffs = useAtomValueContext('groupsDiffs')
    const columnKeys = React.useMemo<IndividualColumnKey[]>(
      () => [
        'answerText',
        ...tabulatedGroupsAndAll,
        ...groupsDiffs.map(getDiffKey),
      ],
      [groupsDiffs, tabulatedGroupsAndAll],
    )

    return React.useMemo(
      () => getColumnInfos(columnKeys, widthMap),
      [columnKeys],
    )
  }
